// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3KofT","emails":"CreateEditClinics_emails__3ugvN","emailTagLabel":"CreateEditClinics_emailTagLabel__E5ePN"};